"use client";

import {
  TEXT,
  TEXT_DIM,
  VIOLET_GLOW,
} from "./palette";
import { TIPS } from "./pedagogy-panel-helpers";
import { PedagogyPanelSectionTitle } from "./pedagogy-panel-section-title";

type Props = {
  inversionIndex: number;
};

export function PedagogyPanelTipTab({ inversionIndex }: Props) {
  const t = TIPS[inversionIndex] ?? TIPS[0];

  return (
    <div>
      <section style={{ marginBottom: 22 }}>
        <PedagogyPanelSectionTitle>{t.title}</PedagogyPanelSectionTitle>
        <div
          style={{
            fontSize: 14,
            color: TEXT,
            fontWeight: 400,
            lineHeight: 1.5,
            padding: "14px 16px",
            background: "rgba(139, 92, 246, 0.06)",
            border: `1px solid ${VIOLET_GLOW}`,
            borderRadius: 10,
          }}
        >
          {t.summary}
        </div>
      </section>

      <section style={{ marginBottom: 22 }}>
        <PedagogyPanelSectionTitle>Quand l'utiliser ?</PedagogyPanelSectionTitle>
        <p style={{ fontSize: 12, color: TEXT_DIM, lineHeight: 1.7 }}>
          {t.use}
        </p>
      </section>

      <section style={{ marginBottom: 22 }}>
        <PedagogyPanelSectionTitle>Dans la musique</PedagogyPanelSectionTitle>
        <p
          style={{
            fontSize: 12,
            color: TEXT_DIM,
            lineHeight: 1.6,
            fontStyle: "italic",
          }}
        >
          {t.example}
        </p>
      </section>

      <section>
        <PedagogyPanelSectionTitle>Astuce de doigté</PedagogyPanelSectionTitle>
        <p style={{ fontSize: 12, color: TEXT_DIM, lineHeight: 1.7 }}>
          Garde la main détendue, le pouce ancré sur la note la plus grave. Les
          doigts <strong style={{ color: TEXT }}>1, 3, 5</strong> forment un
          triangle stable que tu peux déplacer le long du clavier sans changer
          la forme.
        </p>
      </section>
    </div>
  );
}
